<template>
    <div>
        <ul class="list-inline font-min">
            <li class="list-inline-item m-0 font-yellow">Calificación {{star}}</li>
            <li class="list-inline-item m-0" v-show="this.star >= 0">
                <i class="fas fa-star font-yellow" v-if="this.star >= 1"></i>
            </li>
                <i class="fas fa-star font-yellow" v-if="this.star >= 2"></i>
            </li>
                <i class="fas fa-star font-yellow" v-if="this.star >= 3"></i>
            </li>
                <i class="fas fa-star font-yellow" v-if="this.star >= 4"></i>
            </li>
                <i class="fas fa-star font-yellow" v-if="this.star >= 5"></i>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'RatingComment',
    props:{
        star: Number,
    },
    data() {
        return {
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/view/RatingComment.vue